import { Component } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { IonicPage } from 'ionic-angular';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { DataServiceProvider } from '../../providers/data-service/data-service';


@IonicPage()
@Component({
  selector: 'page-sow-list',
  templateUrl: 'sow-list.html',
})
export class SowListPage {
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
    ]
  };
  htmlContent: any;
  tabName: any = '';
  broadcastSubs: any;
  sowListMaster: any = [];
  previousTab: any;
  constructor(public configApiService: ConfigApiServiceProvider, public dataService: DataServiceProvider, public communicationServ: CommunicationServiceProvider) {
  }

  ngOnInit(){
    this.dataService.showPricelistIcon = true;
    this.dataService.showPricelistSave = true;
    this.dataService.ScreenName = 'SOW-LIST';
    this.sowListMaster = this.configApiService.sowListMaster;
    this.tabName = this.sowListMaster[0].service_code;
    this.previousTab = this.tabName;
    this.htmlContent = this.sowListMaster[0].jsonData;
    this.initSowlist();
  }
  initSowlist(){
    this.broadcastSubs = this.communicationServ.getInstance()
    .subscribe((data: any) => {
      if(data.src ===  'proposal-view'){
        if(data.event === 'EDIT_SOW_LIST_MASTER'){
          let flag = data['status'];
          if(flag){
            this.dataService.showPricelistIcon = true;
            this.dataService.showPricelistSave = true;
            let currentDate: any = new Date();
            let currentMonth: any= currentDate.getMonth() + 1;
            let curentDate = currentDate.getFullYear() + '-' + currentMonth.toString().padStart(2, '0') + '-'+ currentDate.getDate().toString().padStart(2, '0');
            this.sowListMaster.forEach(element => {
            let obj = {
            "Sow_List_1_Id": element.Sow_List_1_Id,
            "service_code": element.service_code,
            "service_type": element.service_type,
            "frequency": element.frequency,
            "jsonData": element.jsonData,
            "currentDate": curentDate,
            "status":"1",
            "Tag":"",
            "Created_date":"",
            "Created_By":"",
            "Modified_By":"",
            "Modified_date":"",
            "userid": 3280,
            "rptname":"Sow_List_12566",
            "client":"starport1294"
          }
          let objData = { data: JSON.stringify(obj) }
          this.configApiService.saveContract(objData).subscribe((respdata: any) => {
            if (respdata["_POST_AddMethodResult"].length > 0) {
              if (respdata["_POST_AddMethodResult"][0].Result !== "FAIL") {
              }
            }
          });
        });
            this.configApiService.getSowListMaster();
        }
      }
    }
    });
  }
  segmentChanged(e){
    this.sowListMaster.forEach(element => {
      if(element.service_code == this.previousTab){
        element.jsonData = this.htmlContent;
      }
    });
    this.sowListMaster.forEach(element => {
      if(element.service_code == e["_value"]){
        this.htmlContent = element.jsonData;
        this.previousTab = element.service_code;
      }
    });
  }
  ngOnDestroy() {
    this.dataService.showPricelistIcon = false;
    this.dataService.showPricelistSave = false;
    this.broadcastSubs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/pages/sow-list/sow-list.ts